import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

export const QUERY_KEY = 'GET_PAYROLL_CALENDARS';

export interface PayrollCalendarResponsePayload {
  id: string;
  deactivated: boolean;
  frequency_type: string;
  group_type: string;
  name: string;
  start_date: string;
}

interface ExpandedOption extends Option {
  startDate?: dayjs.Dayjs;
}

const usePayrollCalendarsQuery = () => {
  const {
    observingOrganization: { id },
  } = useCurrentOrganization();
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id],
    () => api.get(API_URL.PAYROLL_CALENDARS_ORGANIZATIONS_BY_ORGANIZATION_ID(id || '')),
    {
      retry: 0,
      enabled: !!id,
    }
  );
  const options = useMemo<ExpandedOption[]>(
    () =>
      (data?.data || []).map(
        (item): ExpandedOption => ({
          key: `${item.id}`,
          title: item.name,
          value: item.name,
          startDate: item.start_date ? dayjs(item.start_date).subtract(1, 'day') : undefined,
        })
      ),
    [data?.data]
  );

  return {
    options,
    data,
    isLoading,
    isSuccess,
  };
};

export default usePayrollCalendarsQuery;
